export default __webpack_public_path__ + "0cf4a11e91c96f72076a117df6db9ad4.svg";